/**
 * 通知ドロワーの行と新着ポップアップの文言 — 日本語 (正本)。
 *
 * ドロワーの枠 (見出し・タブ・すべて既読など) は phase 1 の `shell.notifications`。ここは
 * 通知 1 件の表示 (集約した件数付きの文・日付見出し・種類名・パンくずの面) と、新着ポップアップ。
 * BE が返す `title` と、依頼者名・書類名はデータなので訳さない (ここには置かない)。
 * 日本語は `utils/notificationFormat.ts` などが従来出していた文と同じ (util はこの辞書から描く)。
 */
export const notificationsJa = {
  /** 同じ種類の通知を集約したときの件数付きの文 (`formatGroupedNotificationTitle`)。 */
  group: {
    itemUploadedNamed: '{client}さんが{resource}を{count}件アップロードしました',
    itemUploadedGeneric: '{client}さんが書類を{count}件アップロードしました',
    itemAddedNamed: '{client}さんが書類「{resource}」を{count}件追加しました',
    itemAddedGeneric: '{client}さんが書類を{count}件追加しました',
    itemDeferredNamed: '{client}さんが書類「{resource}」を後日提出にしました',
    itemDeferredGeneric: '{client}さんが書類を後日提出にしました',
    extensionRequestedNamed: '{client}さんが書類「{resource}」の期限の延長をお願いしています',
    extensionRequestedGeneric: '{client}さんが書類の期限の延長をお願いしています',
    messagesReceived: '{client}様から{count}通のメッセージを受信しました',
  },
  /** ドロワーの行の主文・日付見出し。 */
  drawer: {
    documentsCount: '書類 {count}件',
    namedCount: '{name} {count}件',
    unknownDate: '日付不明',
  },
  /** 通知の種類 (8 区分)。種類の絞り込みとパンくずの先頭。 */
  categories: {
    document: '書類提出',
    review: '書類確認',
    message: 'メッセージ',
    guide: '案内・リマインド',
    email: 'メール配信',
    case: '案件',
    task: 'タスク',
    other: 'その他',
  },
  /** パンくずの末尾 (その出来事が起きた面)。 */
  surfaces: {
    collection: '書類回収',
    message: 'メッセージ',
    email: 'メール',
    case: '案件',
    task: 'タスク',
  },
  /** 新着ポップアップ (トースト)。 */
  popup: {
    fallbackTitle: '新着通知',
    messageAction: 'メッセージを確認',
    messageTitle: '{client}様から新着メッセージ',
    aggregated: '新着通知が {count} 件あります',
  },
} as const;
